/* Smile Rewards popup links */
if (!!document.querySelector('[href="https://store.lovelesscafe.com/pages/rewards-program"]')) {
  // console.log('we have reward links',);
  const rewardLinks = document.querySelectorAll('[href="https://store.lovelesscafe.com/pages/rewards-program"]');

  for (let i = 0; i < rewardLinks.length; i++) {
    rewardLinks[i].onclick = function(e){
      // console.log('e',e);
      if (!!document.querySelector('.smile-launcher-frame')) {
        // console.log('open rewards container');
        e.preventDefault();
        SmileUI.openPanel();
      } else {
        // console.log('no rewards container to open');
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  // Watch for changes to the add to cart button text
  const cartButtonObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      // Check if the button text changed to "Added" or the translated equivalent
      if (mutation.type === 'childList' && mutation.target.textContent.includes('Added')) {
        updateCartFromFetch();
      }
    });
  });

  // Observe all add to cart buttons, including quick add buttons
  document.querySelectorAll('#purchase, .product-add, .quick-add-button').forEach(button => {
    cartButtonObserver.observe(button, {
      childList: true,
      characterData: true,
      subtree: true
    });
  });

  // Also watch for form submissions from quick add forms
  document.addEventListener('submit', function(event) {
    if (event.target.closest('.quick-add-wrapper')) {
      // Wait a brief moment for the cart to update
      setTimeout(updateCartFromFetch, 500);
    }
  });

  // Also watch for quantity changes
  document.addEventListener('change', function(event) {
    if (event.target.matches('.quantity-selector')) {
      setTimeout(updateCartFromFetch, 500);
    }
  });

  function updateCartFromFetch() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        updateCartCounts(cart.item_count);
      })
      .catch(error => console.error('Error:', error));
  }

  // Update all cart count elements
  function updateCartCounts(count) {
    document.querySelectorAll('.js-cart-count').forEach(el => {
      el.textContent = count;
    });
  }

  // Initial cart count update
  updateCartFromFetch();
});
